import React from 'react'
import { Modal } from '@material-ui/core'
import jMoment from 'moment-jalaali'
import utils from 'Utils'
import Loading from 'components/Loading'
import 'style/ModalAlert.css'

class ConsultTimerModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
            enableAlertButton: false,
            time: { m: '- -', s: '- -' },
            seconds: 1800,
            maxSecond: 1800,
            showTimer: false,
            timerLoading: false,
        }

        this.counter = 0
    }

    componentDidMount() {
        if (this.props.consultRequest) this.disableAlertDoctorButton()
    }

    componentWillUnmount() {
        clearInterval(this.counter)
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.consultRequest) {
            if (this.counter === 0 && window.localStorage.getItem(this.props.consultRequest.roomId))
                this.disableAlertDoctorButton()

            if (this.state.seconds < 0) {
                clearInterval(this.counter)
                this.counter = 0

                if (prevState.seconds !== this.state.seconds) this.setState({ showTimer: false })
            }
        }
    }

    handleOnClose = () => this.setState({ open: false })

    openModal = () => this.setState({ open: true })

    disableAlertDoctorButton = () => {
        if (!window.localStorage.getItem(this.props.consultRequest.roomId))
            return this.setState({ enableAlertButton: true, seconds: this.state.maxSecond })

        const buttonInfo = JSON.parse(window.localStorage.getItem(this.props.consultRequest.roomId))
        const now = jMoment(new Date)
        const timeClickedAlertDoctorButton = jMoment(buttonInfo.date)
        const diff = now.diff(timeClickedAlertDoctorButton, 'seconds')
        const remainTime = this.state.maxSecond - diff

        if (remainTime > 0) {
            this.setState({ seconds: remainTime, showTimer: true })
            if (this.counter === 0) this.counter = setInterval(this.startTimer, 1000)
        } else {
            window.localStorage.removeItem(this.props.consultRequest.roomId)
            this.setState({ seconds: this.state.maxSecond, showTimer: false })
        }
    }

    startTimer = () => {
        let seconds = this.state.seconds - 1
        this.secondsToTime(seconds)
        this.setState({
            time: this.secondsToTime(this.state.seconds),
            seconds,
        });
    }

    secondsToTime = secs => {
        let divisor_for_minutes = secs % (60 * 60)
        let minutes = Math.floor(divisor_for_minutes / 60)

        let divisor_for_seconds = divisor_for_minutes % 60
        let seconds = Math.ceil(divisor_for_seconds)

        let obj = {
            "m": minutes < 10 ? '0' + minutes : minutes,
            "s": seconds < 10 ? '0' + seconds : seconds
        }

        return obj
    }

    apiAlertDoctor = async () => {
        this.setState({ timerLoading: true })

        let res = await utils.iaxios({
            method: 'POST',
            url: utils.urls.notifyDoctor,
            data: { consultId: this.props.consultRequest.id }
        }, true)
            .catch((e) => {
                console.log(e.response)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.props.openSnackbar(message)
                this.setState({ timerLoading: false })
            })

        if (!res) return
        if (!res.data.success) return this.props.openSnackbar('خطایی رخ داده است')

        this.props.openSnackbar(res.data.message, 'info')

        const { consultRequest: { roomId } } = this.props
        window.localStorage.setItem(roomId, JSON.stringify({ disable: true, date: new Date }))

        if (this.counter === 0) this.counter = setInterval(this.startTimer, 1000)

        this.setState({ showTimer: true, timerLoading: false })

        this.disableAlertDoctorButton()
        this.handleOnClose()
    }

    render() {
        return (
            <Modal
                open={this.state.open}
                onClose={this.handleOnClose}
                className="modal-alert"
            >
                <div className="modal-alert__box">
                    <div className="modal-alert__content">
                        {this.state.showTimer ?
                            <p>شما میتوانید  {this.state.time.m + ':' + this.state.time.s} بعد دوباره دکتر را خبر کنید </p> :
                            <p id="transition-modal-description">در صورت تمایل می‌توانید پزشک را از طریق پیامک مطلع کنید تا پزشک پاسخ شما را بدهد</p>
                        }
                    </div>
                    {this.state.timerLoading ?
                        <div style={{ minWidth: '98px' }}>
                            <Loading style={{
                                margin: 'auto',
                                background: 'rgba(255, 255, 255, 0)',
                                display: 'block',
                                width: 20,
                                height: '100%'
                            }} />
                        </div> :
                        <div className="modal-alert__btn-box">
                            <button className="modal-alert__cancel-btn alert-button" onClick={this.handleOnClose}>انصراف</button>
                            {!this.state.showTimer && <button className="modal-alert__action-btn alert-button" onClick={this.apiAlertDoctor}>خبر کردن</button>}
                        </div>
                    }
                </div>
            </Modal>
        )
    }
}

export default ConsultTimerModal